import script from "./ComputeWizardInputAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputeWizardInputAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./ComputeWizardInputAccordion.vue?vue&type=style&index=0&id=516802f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516802f7"]])

export default __exports__